import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.selectContent);
    this.element.addEventListener("touchstart", this.selectContent);
  }

  disconnect() {
    this.element.removeEventListener("click", this.selectContent);
    this.element.removeEventListener("touchstart", this.selectContent);
  }

  selectContent(event) {
    event.target.select();
  }
}
